import axios from 'axios';
import { useQuery } from 'react-query';
import * as yup from 'yup';
import { carePlanPresetsSchema } from '~/schemas/carePlanPresetsSchema';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .object({
        presets: yup.array(carePlanPresetsSchema),
    })
});
async function getCarePlanPresets() {
    const url = '/api/carePlan/getCarePlanPresets/';
    const response = await axios.get(url);
    const { data } = await responseSchema.validate(response.data);
    return {
        // @ts-ignore
        presets: data.presets,
    };
}
export const useGetCarePlanPresets = () => {
    return useQuery(['getCarePlanPresets'], () => getCarePlanPresets(), {
        staleTime: 1200000,
        refetchOnWindowFocus: true, // Refetch when user returns to tab
    });
};
